import { useEffect } from 'react'
import { Table } from 'antd'
import { ColumnsType } from 'antd/es/table'
import { baseModel } from '../model'
import { IDetail } from '../service'
import {
    DeleteOutlined,
    FormOutlined,
    EyeOutlined,
    SendOutlined,
    StopOutlined,
    ExportOutlined
} from '@ant-design/icons'
import { Button } from 'antd/lib/radio'

export function DataTable() {
    const {
        dataSource,
        selectedRowKeys,
        pgCfg,
        loading,
        setEditVisible,
        setDetailVisible,
        loadData,
        setSelectedRowKeys,
        onDelete,
        meetingsStatusList,
        setItemColor,
        handlePublish,
        handleCancel,
        setMode,
        getDriverList,
        handleExport
    } = baseModel()

    useEffect(() => {
        void loadData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const columns: ColumnsType<IDetail> = [
        {
            title: '序号',
            width: 60,
            align: 'center',
            render: (_t, _r, i) => i + 1
        },
        {
            title: '操作',
            width: 200,
            align: 'left',
            render: (_text, record) => {
                const statusText = meetingsStatusList[record.status as number]
                return (
                    <>
                        {['未发布', '已撤回'].includes(statusText) && (
                            <>
                                <Button
                                    onClick={async () => {
                                        await getDriverList()
                                        setMode('edit')
                                        setEditVisible({ visible: true, value: { ...record } })
                                    }}
                                >
                                    <FormOutlined style={{ cursor: 'pointer' }} title={'编辑'} />
                                </Button>
                                <Button onClick={() => onDelete([record])}>
                                    <DeleteOutlined style={{ cursor: 'pointer' }} title={'删除'} />
                                </Button>
                                <Button onClick={() => handlePublish(record)}>
                                    <SendOutlined style={{ cursor: 'pointer' }} title={'发布'} />
                                </Button>
                                <Button onClick={() => handleExport([record.id as string])}>
                                    <ExportOutlined style={{ cursor: 'pointer' }} title={'导出'} />
                                </Button>
                            </>
                        )}
                        {statusText === '已发布' && (
                            <>
                                <Button onClick={() => handleCancel(record)}>
                                    <StopOutlined style={{ cursor: 'pointer' }} title={'撤回'} />
                                </Button>
                            </>
                        )}
                        <Button onClick={() => setDetailVisible({ visible: true, value: { ...record } })}>
                            <EyeOutlined style={{ cursor: 'pointer' }} title={'查看'} />
                        </Button>
                    </>
                )
            }
        },
        {
            title: '类型',
            width: 160,
            align: 'center',
            dataIndex: 'meetingType'
        },
        {
            title: '主题',
            width: 250,
            align: 'center',
            dataIndex: 'title'
        },
        {
            title: '地点',
            width: 160,
            align: 'center',
            dataIndex: 'location',
            render: (_text, record) => (
                <>
                    <span>{record.location || '-'}</span>
                </>
            )
        },
        {
            title: '时间',
            width: 160,
            align: 'center',
            dataIndex: 'startTime'
        },
        {
            title: '创建人',
            width: 200,
            align: 'center',
            dataIndex: 'createUser'
        },
        {
            title: '状态',
            width: 160,
            align: 'center',
            dataIndex: 'status',
            render: (_text, record) => (
                <>
                    <span className={'text b-text ' + setItemColor((record.status as number))}>
                        {record.status || record.status === 0 ? meetingsStatusList[record.status] : '-'}
                    </span>
                </>
            )
        }
    ]

    //点击行选高亮
    const onRow = (record: IDetail) => {
        let findObj = selectedRowKeys.find((item) => item.id === record.id)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter((item) => item.id !== record.id)
            setSelectedRowKeys(newSelectedRowKeys)
        } else {
            setSelectedRowKeys((origin) => [...origin, record])
        }
    }

    return (
        <Table
            rowKey={(record) => record?.id as string}
            loading={loading}
            rowSelection={{
                // 修改这里
                //全部选中时 (存row[])
                onSelectAll: (selected, _selectedRows, changeRows) => {
                    selected
                        ? setSelectedRowKeys((origin) => [...origin, ...changeRows.filter((item) => item.status !== 1 && item.status !== 2)])
                        : setSelectedRowKeys((origin) => {
                            let changeRowId = changeRows.map((item) => item.id)
                            return origin.filter((item) => changeRowId.indexOf(item.id) < 0)
                        })
                },
                onSelect: (record) => {
                    if (record.status !== 1 && record.status !== 2) {
                        onRow(record)
                    }
                },
                selectedRowKeys: selectedRowKeys.map((item) => item.id as string)
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ['bottomRight'],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: async (pageNum, pageSize) => {
                    await loadData({ pageNum, pageSize })
                },
                showSizeChanger: true
            }}
            bordered
            onRow={(record) => ({
                onClick: () => {
                    if (record.status !== 1 && record.status !== 2) {
                        onRow(record)
                    }
                },
                onContextMenu: (e) => {
                    e.preventDefault()
                    if (record.status !== 1 && record.status !== 2) {
                        setSelectedRowKeys([record])
                    }
                }
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 350px)' }}
        />
    )
}
